export enum Permission {
    ReadUser = 0,
    WriteUser = 1,
    ReadMeasurement = 2,
    WriteMeasurement = 3,
    ReadLocation = 4,
    WriteLocation = 5,
    ReadDevice = 6,
    ReadTenant = 7,
    WriteTenant = 8,
    ImportMeasurement = 9,
    InternalUser = 10,
    ReadFirmware = 11,
    WriteFirmware = 12,
    ROIPermission = 13
}
